import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import PriceRowTaxesAndFees from 'LuxKit/PricePoints/PriceRowTaxesAndFees'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import { useOfferRatePrice } from 'hooks/Offers/useOfferPrice'

const Root = styled.div`
`

interface Props {
  rate?: App.BedbankRate
  offer: App.BedbankOffer | App.BedbankOfferSummary
}

function HeroBedbankPriceDetails(props: Props) {
  const {
    rate,
    offer,
  } = props
  const intl = useIntl()
  const ratePrices = useOfferRatePrice(offer, rate)
  const hotelNights = rate?.nights ?? offer?.sell?.los
  if (!ratePrices) {
    return null
  }

  const {
    totalPrice,
    saleUnit,
    totalValue,
    valueOffPercent,
  } = ratePrices

  return <Root>
    <PriceRowPriceCaption>
      {intl.formatMessage(
        {
          id: 'dpgRKFB0jQ',
          defaultMessage: '{count, plural, one {# night} other {# nights}} from',
          description: 'Duration in nights followed by "from" for hero bedbank price caption',
        },
        { count: hotelNights! },
      )}
    </PriceRowPriceCaption>
    <PriceRowPrice size="L" price={totalPrice} saleUnit={saleUnit} />
    <PriceRowTaxesAndFees />
    {valueOffPercent > 0 && <PriceRowValueDiscountWithCaption
      size="M"
      originalValue={totalValue}
      discountPercentage={valueOffPercent}
    />}
  </Root>
}

export default HeroBedbankPriceDetails
